<template>
  <div
    v-if="isLoading"
    class="background"
  >
    <vue-loading
      type="spin"
      color="#fffff"
      :size="{ width: '50px', height: '50px' }"
    />
  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template'

export default {
  components: {
    VueLoading
  },

  computed: {
    isLoading () {
      return this.$store.getters['loading/getAttr']('isLoading')
    }
  }
}
</script>

<style lang="scss" scoped>
.background {
  position: fixed;
  z-index: 1000;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);

  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
